import type { ComponentProps } from 'react';
import React from 'react';

import { cn } from './cn';

type PageHeaderProps = ComponentProps<'div'> & {
  icon: React.ReactNode;
  title: string;
};

export default function PageHeader({ icon, title, children, className }: PageHeaderProps) {
  return (
    <div className={cn('my-8 flex items-center gap-3 px-8 has-[+nav]:mb-2', className)}>
      <div className="aspect-square size-6 shrink-0 text-slate-500 dark:text-slate-300 *:h-full *:w-auto">
        {icon}
      </div>
      <h1 className="shrink grow-0 truncate p-0 text-2xl font-semibold tracking-tight text-slate-700 dark:text-white">
        {title}
      </h1>
      <div className="flex shrink grow justify-stretch gap-3">{children}</div>
    </div>
  );
}
